import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import './DataGrid.css';
import * as _ from 'lodash';
import { CSVLink } from 'react-csv';
import ReactLoading from 'react-loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { inspect } from 'util';


var delayTimer;

class DataGrid extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.state = { rows: this.props.data };

  }

  componentDidMount() {
    this.refs.grid.onToggleFilter();
  }

  componentDidUpdate(prevProps) {
    let prevData = inspect(prevProps.data);
    let newData = inspect(this.props.data);
    //JSON.stringify was breaking due to a circular reference inspect remove circular references
    if (newData !== prevData) {
      this.applyRowFilters(this.props.rowFilter);
    }

    if (JSON.stringify(this.props.columns) !== JSON.stringify(prevProps.columns)) {
      this.refs.grid.setState({ canFilter: false });
      setTimeout(() => this.refs.grid.setState({ canFilter: true }), 1);
      this.clearFilters();
    }


  }

  rowGetter = (i) => {
      return this.state.rows[i];
  };

  handleFilterChange = (filter) => {

    let newFilters = Object.assign({}, this.props.rowFilter);

    /* Assign filters */

    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }

    clearTimeout(delayTimer);
    delayTimer = setTimeout(() => {
      this.applyRowFilters(newFilters);
    }, 30);
  };

  applyRowFilters = (newFilters) => {
    var filteredRows = this.props.data;
    if (!_.isEmpty(newFilters)) {
      filteredRows = this.props.data.filter(row => {
        return Object.keys(newFilters).every(key => {
          if (row[key]) {
            if (typeof row[key] === "string") {
              return row[key].toUpperCase().includes(newFilters[key].filterTerm.toUpperCase())
            }
            else {
              return row[key].toString().toUpperCase().includes(newFilters[key].filterTerm.toUpperCase())
            }
          } else {
            return false;
          }
        })
      })
    }

    this.props.setFilters(newFilters);
    this.setState({ rows: filteredRows });
  }

  clearFilters = () => {
    this.setState({ rows: this.props.data });
  };

  downloadGrid = () => {
    let csvColumns = [];
    for (let column of this.props.columns) {
      csvColumns.push(column.key);
    }

    return this.state.rows.map(row => {
      return _.pick(row, csvColumns);
    });
  };

  emptyRowsView = () => {
    return <div style={{
      // "display": "flex",
      "min-height": "480px",
      "min-width": "1920px",
      // "justify-content": "center",
      // "align-items": "center"
    }}>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;No data to display, please remove one or more filters and try again.
    </div>
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-12 mb-2">
            <div>
              {this.props.ruleSubmitting && (
                <div className="float-left">
                  <ReactLoading type={"spin"} color={"#666666"} height={'20px'} width={'20px'} />
                </div>
              )}
              <div className="float-right btn btn-primary ">
                <CSVLink data={this.downloadGrid()} filename="rules.csv"  >
                  <span className="text-white">Download</span>
                  <FontAwesomeIcon icon={faDownload} size="lg" color="#666666" className="text-white pl-2" />
                </CSVLink>
              </div>
            </div>
          </div>
        </div>
        <ReactDataGrid
          enableCellSelect={true}
          columns={this.props.columns}
          rowGetter={this.rowGetter}
          rowsCount={this.state.rows ? this.state.rows.length : 0}
          minHeight={window.innerHeight - 200}
          onGridRowsUpdated={this.props.handleGridRowsUpdated}
          onAddFilter={this.handleFilterChange}
          onClearFilters={this.clearFilters}
          emptyRowsView={this.emptyRowsView}
          ref="grid"
        />
      </div>);


  }
}



export default DataGrid;



// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGrid.js